import { FeatureFlag, useFeatureFlag } from '~/lib/flags';
import { useSessionStore } from '~/stores/Session';

const DISPUTE_MANAGEMENT_ROLES = ['owner', 'admin'] as const;

export const canManageCardDisputes = (roleName: string | undefined, managementEnabled: boolean): boolean => {
  if (!managementEnabled || !roleName) {
    return false;
  }
  return (DISPUTE_MANAGEMENT_ROLES as readonly string[]).includes(roleName);
};

export const useCanManageCardDisputes = (): boolean => {
  const managementEnabled = useFeatureFlag(FeatureFlag.CardDisputeManagement);
  const roleName = useSessionStore((state) => state.platformRole?.name);

  return canManageCardDisputes(roleName, managementEnabled);
};
